import { Box, Group } from '@mantine/core';
import type { Initiative } from '../../../../../../api/initiative-client/initiative-client.type';
import { baseWhite } from '../../../../../../styles/design-tokens';
import { Text } from '../../../../../../ui-library/typography/typography';

export const ContributingInitiativesChartTooltip = (props: any) => {
  const { active, payload, label, barColors, initiatives } = props;
  if (active && payload && payload.length) {
    return (
      <div
        style={{
          backgroundColor: baseWhite,
          padding: '8px 12px',
          border: '1px solid #e0e0e0',
          borderRadius: '4px',
          boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
        }}
      >
        <p style={{ margin: '0 0 5px', fontWeight: 'bold' }}>{label}</p>
        {payload.map((entry: any, index: number) => {
          const dataKey = entry.name;
          const initiative = initiatives.find((initiative: Initiative) => initiative.id === dataKey);
          return (
            <Group key={`item-${index}`} gap="xs">
              <Box
                style={{
                  width: '8px',
                  height: '8px',
                  backgroundColor: barColors[dataKey as keyof typeof barColors],
                }}
              />
              <Text>
                {initiative?.name || entry.name}: {entry.value}
              </Text>
            </Group>
          );
        })}
      </div>
    );
  }

  return null;
};
